import { render, staticRenderFns } from "./VabAnchorLink.vue?vue&type=template&id=0be80928&scoped=true"
import script from "./VabAnchorLink.vue?vue&type=script&lang=js"
export * from "./VabAnchorLink.vue?vue&type=script&lang=js"
import style0 from "./VabAnchorLink.vue?vue&type=style&index=0&id=0be80928&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be80928",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0be80928')) {
      api.createRecord('0be80928', component.options)
    } else {
      api.reload('0be80928', component.options)
    }
    module.hot.accept("./VabAnchorLink.vue?vue&type=template&id=0be80928&scoped=true", function () {
      api.rerender('0be80928', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabAnchor/components/VabAnchorLink.vue"
export default component.exports